import { createSelector } from 'reselect';
import { subselect } from './root';
import { loadedDataSelector } from './loadedData';
import { answerSelector } from './answer';
import { revealAnswerSelector } from './revealAnswer';

const choicesSelector = createSelector(
  [loadedDataSelector, answerSelector, revealAnswerSelector],
  (loadedData, answer, revealAnswer) =>
    loadedData &&
    loadedData.choices.map((choice) => ({
      label: choice,
      value: choice,
      isCorrect: answer && revealAnswer ? choice === answer.correctChoice : undefined,
    })),
);

export const triviaChoicesSelector = subselect(choicesSelector);
